var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Presentation50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    d: "M23 5H25V40H23z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFD8DC",
    d: "M4 5H44V34H4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#607D8B",
    d: "M45,9H3V5h42V9z M45,33H3v2h42V33z M22,40c0,1.104,0.896,2,2,2s2-0.896,2-2s-0.896-2-2-2S22,38.896,22,40"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#C2185B",
    d: "M15,15c-3.866,0-7,3.134-7,7s3.134,7,7,7s7-3.134,7-7h-7V15z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E91E63",
    d: "M17,13v7h7C24,16.134,20.866,13,17,13z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#90A4AE",
    d: "M40,16H28v-2h12V16z M38,18H28v2h10V18z M40,22H28v2h12V22z M38,26H28v2h10V26z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Presentation50);
export default __webpack_public_path__ + "static/media/icons8-presentation-50.5998b438daadba234a8ae078b51b402c.svg";
export { ForwardRef as ReactComponent };